// @flow

import { Fragment } from 'react';
import styled from 'styled-components';
import { Card, Button } from '@blueprintjs/core';
import ThumbnailWithStatelemsPlaceholderImage from '../thumbnail-with-statelems-placeholder-image';
import ThumbnailWithStatelemsSingleImageDisplayer from './thumbnail-with-statelems-single-image-displayer';
import { ThumbnailWithLocationNameWithStatelems } from '../../models/query-response';

const StyledCard = styled(Card)`
  display: flex;
  flex-direction: column;
  max-width: 400px;
  max-height: 70vh;
  overflow-y: scroll;
  &&& {
    box-shadow: none;
  }
`;
const StyledButton = styled(Button)`
  margin-top: 1rem;
`;

type Props = {
  previews: ThumbnailWithLocationNameWithStatelems[],
  setMetricPreviewImagesForModal?: (previews: ThumbnailWithLocationNameWithStatelems[]) => void | null,
  useSimpleImageTag?: boolean
};

const ThumbnailImageWithStatelemsDisplayerMenu = ({
  setMetricPreviewImagesForModal,
  previews,
  useSimpleImageTag
}: Props) => {
  const showButton = previews && previews.length > 1;
  return (
    <StyledCard>
      {previews && (
        <Fragment>
          {useSimpleImageTag ? (
            <ThumbnailWithStatelemsPlaceholderImage thumb={previews[0]} width="100%" height="auto" />
          ) : (
            <ThumbnailWithStatelemsSingleImageDisplayer thumb={previews[0]} />
          )}
          {setMetricPreviewImagesForModal && showButton && (
            <StyledButton
              onClick={() => setMetricPreviewImagesForModal(previews)}
              icon="search"
              intent="primary"
            >
              Show {previews.length - 1} more images
            </StyledButton>
          )}
        </Fragment>
      )}
    </StyledCard>
  );
};

export default ThumbnailImageWithStatelemsDisplayerMenu;
